<div class="year-calendar-container">
    <header class="calendar-header">
        <p class="calendar-current-date">{{ year }}</p>
        <div class="calendar-navigation">
            <span (click)="changeYear(-1)" class="material-symbols-rounded">
                <mat-icon>chevron_left</mat-icon>
            </span>
            <span (click)="changeYear(1)" class="material-symbols-rounded">
                <mat-icon>chevron_right</mat-icon>
            </span>
        </div>
    </header>

    <div class="months-grid">
        @for (month of monthsData; track month.monthIndex) {
        <div class="month-card">
            <div class="month-header">{{ month.name }}</div>
            <div class="month-body">
                <ul class="calendar-weekdays">
                    @for (day of weekDays; track day) {
                    <li>{{ day }}</li>
                    }
                </ul>
                <ul class="calendar-dates">
                    @for (dayObj of month.days; track $index) {
                    <li [class]="dayObj.class">
                        {{ dayObj.day > 0 ? dayObj.day : '' }}
                    </li>
                    }
                </ul>
            </div>
        </div>
        }
    </div>
</div>
